import { ReactElement } from 'react'

import { renderIfAllowed } from 'lib/authorization/AuthorizeComponent'

export const renderIfAllowedWithElse = (
  key: string,
  newDashoboardLink: ReactElement,
  oldDashboardLink: ReactElement | undefined,
) => {
  const result = renderIfAllowed(key, newDashoboardLink)

  return result || oldDashboardLink
}
